// All the installation codes
import './bootstrap'
import './vue-codes'
import Modal from './modal'

if ($('.modal').length >= 1) {
    var modal = new Modal('#my-modal', '.modal-trigger');
}

if (window.frameElement) { // in iframe
    var modal = window.parent.$('.modal');
    $('.btn-cancel').on('click', function () {
        modal.modal('hide');
    });
} else { // not in iframe
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "300",
        "timeOut": "6000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
}

function previewUploadImage(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
            document.querySelector('label[for="' + input.id + '"] > img').src = e.target.result
        }
        reader.readAsDataURL(input.files[0]);
    }
}

var uploadBtns = document.querySelectorAll(".preview-upload-image")
uploadBtns.forEach(function (uploadBtn) {
    uploadBtn.addEventListener("change", function () {
        previewUploadImage(this)
    })
})

window.confirmChangeStatus = function (ele) {
    const btnUpdateStatus = $('#btnUpdateStatus')
    btnUpdateStatus.attr('data-url', ele.dataset.url)
    $('#confirmStatusModal').modal('show')
}

window.updateStatus = function (ele) {
    axios({
        method: "PUT",
        url: ele.dataset.url,
    })
        .then((response) => {
            location.reload();
        })
        .catch((error) => {
            alert("Can't update status");
            location.reload();
        });
}

let submitBtns = document.getElementsByClassName("submit-all-forms");
if (submitBtns.length > 0) {
    for (let i = 0; i < submitBtns.length; i++) {
        const btn = submitBtns[i];
        btn.addEventListener("click", function () {
            this.disabled = true;
            let formLanguages = document.querySelectorAll(".tab-content form");
            formLanguages.forEach(function (form) {
                var formData = new FormData(form);
                axios.post(form.action, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((response) => {
                    setTimeout(() => {
                        window.frameElement.srcdoc = response.data
                    }, 1000);
                }).catch((error) => {
                    console.error(error);
                });
            });
        });
    }
}
